import React, { useEffect, useState } from "react";
import UploadModal from "./UploadModal";
import { createAddonsPlan, getAddonsAdmin, updateAddonsPlan } from "../../requests";
import { notifyError, notifySuccess } from "../../utils/helper";
import { startLoader, stopLoader } from "../../_store/reducers/loaderReducer";
import { useDispatch } from "react-redux";

const Index = () => {
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const [editingData, setEditingData] = useState(null);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    fetchAddons();
  }, []);

  const fetchAddons = async () => {
    const response = await getAddonsAdmin();
    if (response.status == 200) {
      setList(response.data.addons);
    }
  };

  const handleAddAddOn = async (newAddOn) => {
    // add the add on in the database
    setShowUploadModal(false);
    dispatch(startLoader())
    try {
      const response = await createAddonsPlan(newAddOn);
      dispatch(stopLoader())
      if (response.status == 200) {
        notifySuccess("Add on plan created successfully");
        fetchAddons();
      }
    } catch (error) {
      dispatch(stopLoader())
      notifyError(error?.response?.data?.error || "Something went wrong");
    }
  };

  const handleEdit = (row) => {
    setEditingId(row.id);
    setEditingData({
      id: row.id,
      name: row.name,
      credits: row.credits,
      price: row.price,
      status: row.status,
    });
    setOpen(null);
  };

  const handleCancelEdit = () => {
    setEditingId(null);
    setEditingData(null);
  };

  const handleSave = async () => {
    if (!editingData?.name?.trim()) return;

    // update the add on in the database
    dispatch(startLoader())
    try {
      const response = await updateAddonsPlan(editingData);
      dispatch(stopLoader())
      notifySuccess(response?.data?.message || "Add on plan updated successfully");
      fetchAddons();
    } catch (error) {
      dispatch(stopLoader())
      notifyError(error?.response?.data?.error || "Something went wrong");
    }

    setEditingId(null);
    setEditingData(null);
  };

  const handleToggleStatus = async(row) => {
    const action = row.status === 1 ? 0 : 1;
    // if (!window.confirm(`Are you sure you want to ${action} this add-on?`)) return;

    dispatch(startLoader())
    try {
      const response = await updateAddonsPlan({
        ...row,
        status: action,
      });
      dispatch(stopLoader())
      notifySuccess(response?.data?.message || "Add on plan updated successfully");
      fetchAddons();
    } catch (error) {
      dispatch(stopLoader())
      notifyError(error?.response?.data?.error || "Something went wrong");
    }
    // update the add on status in the database

    setOpen(null);
  };

  return (
    <div className="addon-page" onMouseDown={() => setOpen(null)}>
      <div className="teacher-container">
        <div className="teacher-head">
          <div className="teacher-head-text">Add On Management</div>
          <div className="teacher-head-right">
            <button
              type="button"
              className="teacher-head-add addon-btn-add"
              onClick={() => setShowUploadModal(true)}
            >
              Add Add On Plan
            </button>
          </div>
        </div>
        <div className="teacher-table addon-table" style={{ borderTop: "none" }}>
          <div className="teacher-table-head">
            <div className="teacher-table-head-cell" style={{ width: "8%" }}>
              S. No
            </div>
            <div className="teacher-table-head-cell" style={{ width: "22%" }}>
              Name
            </div>
            <div className="teacher-table-head-cell" style={{ width: "14%" }}>
              Credits
            </div>
            <div className="teacher-table-head-cell" style={{ width: "14%" }}>
              Price
            </div>
            <div className="teacher-table-head-cell" style={{ width: "12%" }}>
              Status
            </div>
            <div
              className="teacher-table-head-cell"
              style={{ width: "20%", textAlign: "center" }}
            >
              Actions
            </div>
          </div>

          {list.length === 0 && (
            <div className="addon-empty">No add-on plans found</div>
          )}

          {list.map((row, i) => {
            const isEditing = editingId === row.id;
            return (
              <div
                key={row.id}
                className="teacher-table-row"
                style={{
                  borderBottom: i === list.length - 1 ? "none" : "1px solid #d1d5db",
                }}
              >
                <div className="teacher-table-row-cell" style={{ width: "8%" }}>
                  {i + 1}
                </div>
                <div className="teacher-table-row-cell" style={{ width: "22%" }}>
                  {isEditing ? (
                    <input
                      type="text"
                      value={editingData?.name ?? ""}
                      onChange={(e) =>
                        setEditingData({ ...editingData, name: e.target.value })
                      }
                      className="addon-input"
                    />
                  ) : (
                    row.name
                  )}
                </div>
                <div className="teacher-table-row-cell" style={{ width: "14%" }}>
                  {isEditing ? (
                    <input
                      type="text"
                      value={editingData?.credits ?? ""}
                      onChange={(e) =>
                        setEditingData({
                          ...editingData,
                          credits: e.target.value,
                        })
                      }
                      placeholder="Credits"
                      className="addon-input"
                    />
                  ) : (
                    row.credits ?? "-"
                  )}
                </div>
                <div className="teacher-table-row-cell" style={{ width: "14%" }}>
                  {isEditing ? (
                    <input
                      type="text"
                      value={editingData?.price ?? ""}
                      onChange={(e) =>
                        setEditingData({
                          ...editingData,
                          price: e.target.value,
                        })
                      }
                      placeholder="Price"
                      className="addon-input"
                    />
                  ) : (
                    row.price ?? "-"
                  )}
                </div>
                <div className="teacher-table-row-cell" style={{ width: "12%" }}>
                  <span
                    className={`addon-status addon-status-${row.status === 1 ? "active" : "inactive"}`}
                  >
                    {row.status === 1 ? "Active" : "Inactive"}
                  </span>
                </div>
                <div
                  className="teacher-table-row-cell"
                  style={{ width: "20%", textAlign: "center" }}
                >
                  {isEditing ? (
                    <div className="addon-actions-inline">
                      <button
                        type="button"
                        onClick={handleSave}
                        className="my-btn addon-btn-save"
                      >
                        Save
                      </button>
                      <button
                        type="button"
                        onClick={handleCancelEdit}
                        className="my-btn addon-btn-cancel"
                      >
                        Cancel
                      </button>
                    </div>
                  ) : (
                    <div className="dropdown addon-dropdown">
                      <button
                        type="button"
                        onClick={() => setOpen(row.id)}
                        className="dropdown-btn"
                      >
                        ⋮
                      </button>
                      {open === row.id && (
                        <div className="dropdown-content">
                          <div
                            className="option"
                            onMouseDown={() => handleEdit(row)}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              strokeWidth="1.5"
                              stroke="currentColor"
                              className="drp-icon"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M16.862 4.487l1.687 1.687m-2.79-2.79l-9.193 9.193a4.5 4.5 0 00-1.126 2.012l-.376 1.502a.75.75 0 00.94.94l1.502-.376a4.5 4.5 0 002.012-1.126l9.193-9.193m0 0l-1.687-1.687"
                              />
                            </svg>
                            Edit
                          </div>
                          <div
                            className="option"
                            onMouseDown={() => handleToggleStatus(row)}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              strokeWidth="1.5"
                              stroke="currentColor"
                              className="drp-icon"
                              style={{
                                color: row.status === 1 ? "#991B1B" : "#065F46",
                              }}
                            >
                              {row.status === 1 ? (
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M18.364 5.636a9 9 0 11-12.728 12.728A9 9 0 0118.364 5.636zM8.464 8.464l7.072 7.072"
                                />
                              ) : (
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                />
                              )}
                            </svg>
                            {row.status === 1 ? "Deactivate" : "Activate"}
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <UploadModal
        open={showUploadModal}
        onClose={() => setShowUploadModal(false)}
        onSubmit={handleAddAddOn}
      />
    </div>
  );
};

export default Index;
